export default __webpack_public_path__ + "static/media/heart-o-dark.f30dd8d0.svg";